<template>
  <div>
    <div class="wrap1 flex-col">
      <div class="main7">
        <div class="word5" :style="getFontStyle(contractProgressInfo)">
          实验编号：{{ contractProgressInfo.contractNo }}
        </div>
        <div
          style="margin-right: 15px; display: flex"
          @click="handleToExtension()"
        >
          <span
            :class="getStatusClass(contractProgressInfo.status)"
            class="txt2 txt"
          >
            {{ contractProgressInfo.status }}
          </span>
          <!-- <img
            class="label3"
            referrerpolicy="no-referrer"
            src="/static/img/展开后svg"
          /> -->
          <!-- <img
            class="label3"
            referrerpolicy="no-referrer"
            src="/static/img/SketchPng242d1b9291daffe1b3b5e7f021612d0aa757fd5a85fd7599909d623f819ca2ed.png"
          /> -->
          <svg
            v-if="contractProgressInfo.show"
            class="label3"
            width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>编组 4#merge#</title>
            <g id="进展查询" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="进展详情" transform="translate(-334.000000, -261.000000)" fill="#5878FA" fill-rule="nonzero">
                <g id="展-开" transform="translate(342.000000, 269.000000) scale(1, -1) translate(-342.000000, -269.000000) translate(334.000000, 261.000000)">
                  <path d="M8.00000975,15.911638 C3.62514752,15.911638 0.0800005364,12.366491 0.0800005364,8.00000975 C0.0800005364,3.63352848 3.62514752,0.0883814985 8.00000975,0.0883814985 C12.374872,0.0883814985 15.911638,3.63352848 15.911638,8.00839071 C15.911638,12.374872 12.366491,15.911638 8.00000975,15.911638 Z M8.00000975,14.9813512 C11.8552523,14.9813512 14.9813512,11.8552523 14.9813512,8.00000975 C14.9813512,4.14476717 11.8552523,1.0186683 8.00000975,1.0186683 C4.14476717,1.0186683 1.0186683,4.14476717 1.0186683,8.00000975 C1.0186683,11.8552523 4.14476717,14.9813512 8.00000975,14.9813512 Z M8.09220034,9.48344005 C9.46667813,8.11734322 9.91086912,7.68991415 11.2853469,6.32381733 C11.4278233,6.18134097 11.5870615,6.10591231 11.7882046,6.15619808 C12.1653479,6.2400077 12.3162053,6.67581774 12.0731573,6.96915141 C12.0480145,7.00267526 12.0144906,7.02781814 11.9893477,7.06134199 C10.4891555,8.55315325 9.91925008,9.10629675 8.41905786,10.598108 C8.14248611,10.8662988 7.86591436,10.8662988 7.59772357,10.598108 C6.08915039,9.09791579 5.510864,8.53639133 4.00229081,7.04458007 C3.8514335,6.89372275 3.7843858,6.72610351 3.83467157,6.52496042 C3.91010023,6.25676963 4.18667198,6.09753135 4.45486277,6.16457905 C4.52191047,6.18134097 4.58895816,6.21486482 4.63924394,6.25676963 C4.67276779,6.28191252 4.70629163,6.31543636 4.73981548,6.34896021 C6.10591231,7.70667608 6.54172234,8.13410515 7.90781917,9.48344005 C7.93296206,9.50858294 7.95810494,9.55048775 8.00000975,9.60915448 C8.04191456,9.55048775 8.06705745,9.50858294 8.09220034,9.48344005 Z" id="形状"></path>
                </g>
              </g>
            </g>
          </svg>
          <svg
            v-else
            class="label3"
            width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>编组 4#merge# 2</title>
            <g id="进展查询" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="进展详情" transform="translate(-334.000000, -261.000000)" fill="#5878FA" fill-rule="nonzero">
                <g id="展-开" transform="translate(334.000000, 261.000000)">
                  <path d="M8.00000975,15.911638 C3.62514752,15.911638 0.0800005364,12.366491 0.0800005364,8.00000975 C0.0800005364,3.63352848 3.62514752,0.0883814985 8.00000975,0.0883814985 C12.374872,0.0883814985 15.911638,3.63352848 15.911638,8.00839071 C15.911638,12.374872 12.366491,15.911638 8.00000975,15.911638 Z M8.00000975,14.9813512 C11.8552523,14.9813512 14.9813512,11.8552523 14.9813512,8.00000975 C14.9813512,4.14476717 11.8552523,1.0186683 8.00000975,1.0186683 C4.14476717,1.0186683 1.0186683,4.14476717 1.0186683,8.00000975 C1.0186683,11.8552523 4.14476717,14.9813512 8.00000975,14.9813512 Z M8.09220034,9.48344005 C9.46667813,8.11734322 9.91086912,7.68991415 11.2853469,6.32381733 C11.4278233,6.18134097 11.5870615,6.10591231 11.7882046,6.15619808 C12.1653479,6.2400077 12.3162053,6.67581774 12.0731573,6.96915141 C12.0480145,7.00267526 12.0144906,7.02781814 11.9893477,7.06134199 C10.4891555,8.55315325 9.91925008,9.10629675 8.41905786,10.598108 C8.14248611,10.8662988 7.86591436,10.8662988 7.59772357,10.598108 C6.08915039,9.09791579 5.510864,8.53639133 4.00229081,7.04458007 C3.8514335,6.89372275 3.7843858,6.72610351 3.83467157,6.52496042 C3.91010023,6.25676963 4.18667198,6.09753135 4.45486277,6.16457905 C4.52191047,6.18134097 4.58895816,6.21486482 4.63924394,6.25676963 C4.67276779,6.28191252 4.70629163,6.31543636 4.73981548,6.34896021 C6.10591231,7.70667608 6.54172234,8.13410515 7.90781917,9.48344005 C7.93296206,9.50858294 7.95810494,9.55048775 8.00000975,9.60915448 C8.04191456,9.55048775 8.06705745,9.50858294 8.09220034,9.48344005 Z" id="形状"></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div
        class="main8 flex-col"
        v-if="contractProgressInfo.progressNotes.length > 0"
        :class="{
          mianb:
            contractProgressInfo.progressNotes.length > 0 &&
            contractProgressInfo.show,
        }"
      ></div>
      <div v-if="contractProgressInfo.show">
        <template v-if="contractProgressInfo.progressNotes.length > 0">
          <div class="main9 flex-row justify-between">
            <div class="outer2 flex-col"></div>
            <div class="outer3 flex-col">
              <span
                class="txt3"
                @click="handleToHistoryProgress(contractProgressInfo)"
              >历史进展</span
              >
            </div>
          </div>
          <span class="paragraph1">
            <!-- <span v-for="(item,index) in contractProgressInfo.progressNotes"  :key="index" style="margin-top:5px">
                  {{index+1}}.&nbsp; {{item}}
                  <br>
                </span> -->
            <span style="margin-top: 5px">
              1.&nbsp; {{ contractProgressInfo.progressNotes[0].content }}
            </span>
          </span>
        </template>
        <div class="main10 flex-col"></div>
        <div
          v-for="(item, index) in contractProgressInfo.experimentModules"
          :key="index"
        >
          <div
            class="main11"
            @click="handleToExperimentDetail(item.taskModules)"
          >
            <!-- <div class="layer4 flex-col"><div class="main14 flex-col"></div></div> -->
            <div style="display: flex">
              <div
                v-if="item.completedPercent !== '100'"
                class="pie-simple layer4"
                :style="{ '--percent': item.completedPercent }"
                :class="{ allcomplete: item.completedPercent === '100' }"
              >
                <div class="pie-left flex-col"></div>
                <div class="pie-right flex-col"></div>
              </div>
              <div v-else>
                <svg
                  style="display: block;
                       margin: auto;
                       margin-top: 3px;"
                  class="left1"
                  width="14px"
                  height="14px"
                  viewBox="0 0 14 14"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
                  <title>对勾#merge#</title>
                  <desc>Created with Sketch.</desc>
                  <g
                    id="课题组"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g
                      id="进展查询-病毒"
                      transform="translate(-28.000000, -198.000000)"
                      fill="#5878FA"
                      fill-rule="nonzero"
                    >
                      <g
                        id="对勾#merge#"
                        transform="translate(28.000000, 198.000000)"
                      >
                        <path
                          d="M7,0 C3.12083789,0 0,3.12083789 0,7 C0,10.8791621 3.12083789,14 7,14 C10.8791621,14 14,10.8791621 14,7 C14,3.12083789 10.8791621,0 7,0 Z M11.375,5.25 L6.7375,9.8875 L6.73749997,9.88750003 C6.39225641,10.2085075 5.85774352,10.2085075 5.51249997,9.88749997 L2.62499997,6.99999997 C2.62499997,6.99999997 2.18749997,6.56249997 2.62499997,6.12499997 C3.06249997,5.68749997 3.49999997,6.12499997 3.49999997,6.12499997 L6.12499997,8.74999997 L10.5,4.37499997 C10.5,4.37499997 10.9375,3.93749997 11.375,4.37499997 C11.8125,4.81249997 11.375,5.24999997 11.375,5.24999997 L11.375,5.25 Z"
                          id="形状"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <!-- <img
              class="icon4"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngf43ed172808444df487a40d7c2db6d4b85872d1f79593dd5a0e98157ed562462.png"
            /> -->
              <span
                class="info5"
                :style="{ color: item.isException ? 'red' : '' }"
              >{{ item.experimentName }}</span
              >
            </div>
            <div style="display: flex;" :style="item.isException ? { 'margin-top': '4px'}: ''">
              <span
                class="txt2 layer7"
                v-if="item.isException"
                style="margin-right: 15px"
              >
               {{getExceptionName()}}
              </span>
              <img
                class="label4"
                referrerpolicy="no-referrer"
                src="/static/img/SketchPngf5a755bb1e7cc63077d460c4e20c96f4462ddbe798b160a88a0eb60fb5e54057.png"
              />
            </div>
          </div>
          <div
            class="main8 flex-col"
            :class="{
              mianb: index < contractProgressInfo.experimentModules.length - 1,
            }"
          ></div>
        </div>
      </div>
    </div>
    <span class="txt4" v-if="contractProgressInfo.progressNotes.length > 0"
    >{{
        contractProgressInfo.progressNotes[0].createDT
      }}&nbsp;最新进展：<svg width="25px" height="11px" viewBox="0 0 25 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>最新</title>
    <g id="进展查询" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="进展详情" transform="translate(-192.000000, -308.000000)" fill-rule="nonzero">
            <g id="最新" transform="translate(192.000000, 308.000000)">
                <path d="M4.71428418,0 L24.357126,0 L24.357126,6.28571582 L24.357126,6.28571582 C24.357126,8.88934277 22.2464688,11 19.6428418,11 L3.93262024e-15,11 L3.93262024e-15,4.71428418 L3.93262024e-15,4.71428489 C3.93262024e-15,2.11065794 2.11065723,0 4.71428418,0 L4.71428418,0 Z" id="路径" fill="#FE654D"></path>
                <path d="M5.35777988,7.85716895 L5.35777988,2.62429492 L6.42556943,2.62429492 L7.94592197,5.41044238 L8.46920723,6.54187402 L8.50456438,6.54187402 C8.44799291,5.99737402 8.37020755,5.30437402 8.37020755,4.71037402 L8.37020755,2.62429492 L9.36020755,2.62429492 L9.36020755,7.85716895 L8.2994928,7.85716895 L6.78620862,5.05687402 L6.25585179,3.93252148 L6.22049463,3.93252148 C6.26999463,4.49823623 6.34777988,5.15587402 6.34777988,5.75695312 L6.34777988,7.85716895 L5.35777988,7.85716895 L5.35777988,7.85716895 Z M10.6542842,7.85715713 L10.6542842,2.62429492 L13.8647158,2.62429492 L13.8647158,3.49408018 L11.7008633,3.49408018 L11.7008633,4.703296 L13.5394316,4.703296 L13.5394316,5.58015283 L11.7008633,5.58015283 L11.7008633,6.98030029 L13.9425107,6.98030029 L13.9425107,7.85715713 L10.6542842,7.85715713 L10.6542842,7.85715713 Z M15.4982158,7.85714746 L14.4870011,2.62429492 L15.5547863,2.62429492 L15.9720011,5.1770791 C16.0497868,5.72865068 16.1346442,6.28729492 16.2124295,6.84593164 L16.2407152,6.84593164 C16.3467867,6.28728848 16.4599299,5.7215791 16.573072,5.1770791 L17.1812152,2.62429492 L18.0722152,2.62429492 L18.6803583,5.1770791 C18.7935015,5.71450752 18.8995731,6.28022656 19.0127152,6.84593164 L19.0480723,6.84593164 C19.125858,6.28021689 19.2036439,5.7215791 19.2814292,5.1770791 L19.6915723,2.62429492 L20.6886439,2.62429492 L19.7198587,7.85714746 L18.4187112,7.85714746 L17.8317828,5.269 L17.8317825,5.26899871 C17.7473926,4.86765555 17.6719452,4.46448514 17.6054973,4.05978289 L17.5772116,4.05978289 C17.5064973,4.45578289 17.4357832,4.85885447 17.3509263,5.26899871 L16.7781411,7.85714746 L15.4982094,7.85714746 L15.4982158,7.85714746 Z" id="形状" fill="#FFFFFF"></path>
            </g>
        </g>
    </g>
</svg></span
    >
  </div>
</template>
<script>
    import EMKT from '../../../emkt.js'
    import {serviceProgressMixIn} from '@/views_v_2.6/PrivateMixins/ProgressMixin.js'
    export default {
      mixins: [serviceProgressMixIn],
      data () {
        return {}
      },
      props: {
        contractProgressInfo: Object,
        aberrationType: Number
      },
      methods: {
        handleToExtension () {
          this.contractProgressInfo.show = !this.contractProgressInfo.show
        },
        getFontStyle ({experimentModules}) {
          const exceptionList = experimentModules.filter(
                    (item) => {
                      return item.isException
                    }
                )
          if (exceptionList.length > 0) {
            return {
              color: 'red'
            }
          } else {
            return {}
          }
        },
        getExceptionName () {
          console.log(this.aberrationType)
          return this.aberrationType ? EMKT.ADBERRATION_STATUS[this.aberrationType] : ''
        },
        handleToHistoryProgress (contractProgressInfo) {
          this.$router.push({
            name: 'HistoryProgressDetail',
            params: contractProgressInfo
          })
        },
        handleToExperimentDetail (taskModules) {
          const {contractNo, status} = this.contractProgressInfo
          this.$router.push({
            name: 'ExperimentDetail',
            params: {
              contractNo,
              status,
              taskModules
            }
          })
        }
      }
    }
</script>
<style scoped>
  .pie-simple {
    background-color: white;
    border-radius: 50%;
    overflow: hidden;
  }
  .pie-left,
  .pie-right {
    width: 50%;
    height: 100%;
    float: left;
    position: relative;
    overflow: hidden;
  }
  .pie-left::before,
  .pie-right::before,
  .pie-right::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgb(145, 145, 145);
  }
  .pie-left::before {
    left: 100%;
    transform-origin: left;
    transform: rotate(calc(3.6deg * (var(--percent) - 50)));
    opacity: calc(99999 * (var(--percent) - 50));
  }
  .pie-right::before {
    right: 100%;
    transform-origin: right;
    transform: rotate(calc(3.6deg * var(--percent)));
  }
  .pie-right::after {
    opacity: calc(99999 * (var(--percent) - 50));
  }



  .wrap1 {
    margin-top: 13px;
  }

  .main7 {
    height: 20px;
    margin-left: 15px;
    display: flex;
    margin-bottom: 10px;
    justify-content: space-between;
  }



  .txt2 {
    width: 45px;
    height: 15px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 10px;
    white-space: nowrap;
    line-height: 15px;
    text-align: center;
    margin-left: 3px;

  }
  .txt {
    margin-top: 2px;
  }

  .label3 {
    width: 16px;
    height: 16px;
    margin: 2px 0 0 9px;
  }

  .main8 {
    height: 1px;
    background: url(/static/img/SketchPng6799fd0a248a71aa1c89dfa7306d422c500ce1cdb8d468ad498d14b34892f939.png)
    100% no-repeat;
    margin-top: 12px;
  }
  /* .mianb {
    border-top: 1px solid #e7e7e7;
  } */

  .main9 {
    height: 23px;
    margin: 10px 15px 0 15px;
  }

  .outer2 {
    width: 25px;
    height: 11px;
    /*background: url(/static/img/SketchPngcec0eeae0e5dfed917ec66acd191a0323380e41b8843bc2fbc2565a7e1510acf.png)*/
    /*100% no-repeat;*/
    margin-top: 6px;
  }

  .outer3 {
    height: 23px;
    border-radius: 11.5px 11.5px 11.5px 11.5px;
    border: 1px solid rgba(88, 120, 250, 1);
    width: 70px;
  }

  .txt3 {
    width: 70px;
    height: 17px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(88, 120, 250, 1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 17px;
    text-align: center;
    margin-top: 3px;
  }

  .paragraph1 {
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 12px;
    line-height: 20px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 6px 0 0 15px;
    word-wrap: normal;
    margin-right: 10px;
    margin-top: 10px;
  }

  .main10 {
    height: 1px;
    background: url(/static/img/SketchPngc23a87c8cf46a02bf5caeda53083f8505a8cc76dd04bb2461e56e50d60186783.png)
    100% no-repeat;
    /* border-top: 1px solid #e7e7e7; */
    margin-top: 10px;
  }

  .main11 {
    height: 20px;
    margin: 20px 0 0 15px;
    display: flex;
    justify-content: space-between;
  }

  .info5 {
    width: 79px;
    height: 20px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    white-space: nowrap;
    line-height: 20px;
    text-align: left;
    margin-left: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    width: 60.2vw;
  }

  .label4 {
    width: 7px;
    height: 12px;
    margin-top: 2px;
    margin-right: 15px;
  }



  .layer4 {
    height: 14px;
    border-radius: 50%;
    background: url(/static/img/SketchPng1bbe67ca567ccccaec7bd9677cb47290c57d46c9c011d39b0757bb6add1beb1a.png)
    100% no-repeat;
    margin-top: 3px;
    width: 14px;
  }




  .txt4 {
    z-index: 38;
    position: absolute;
    left: 15px;
    top: 59px;
    width: 168px;
    height: 17px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 12px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 17px;
    text-align: left;
    margin-top: 12px;
  }



  .word5 {
    height: 20px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 20px;
    text-align: left;
  }


  .mod1 {
    border-radius: 7.5px 7.5px 7.5px 7.5px;
    background-color: rgba(255, 148, 0, 1);
  }
  .layer6 {
    border-radius: 7.5px 7.5px 7.5px 7.5px;
    background-color: rgba(96, 216, 55, 1);
  }
  .layer7 {
    border-radius: 7.5px 7.5px 7.5px 7.5px;
    background-color:   #FE654D;
  }

  .layer5 {
    border-radius: 7.5px 7.5px 7.5px 7.5px;
    background-color: rgba(151, 151, 151, 1);
  }
  .mianb{

  }
</style>



// WEBPACK FOOTER //
// ContractProgressInfo.vue?2fc864bc